import { ILocalizedTestElement, ISectionConfig, ITestElement } from "@/modules/assessments/types/test.interface";

// These helpers only read fields shared by the stored and locale-resolved element shapes.
type AnyTestElement = ITestElement | ILocalizedTestElement;

function getCurrentElementIndex(elements: AnyTestElement[], currentElementKey: string): number {
  return elements.findIndex((element) => element.config.key === currentElementKey);
}

export function getNextElementStartSectionConfig(
  elements: AnyTestElement[],
  currentElementKey: string,
): ISectionConfig | undefined {
  const currentElementIndex = getCurrentElementIndex(elements, currentElementKey);
  const nextElement = elements[currentElementIndex + 1];

  return nextElement ? nextElement.config.startsSection : undefined;
}

export function isPreviousElementWithBreakAfter(currentElementKey: string, elements?: AnyTestElement[]): boolean {
  if (!elements) {
    return false;
  }
  const currentElementIndex = getCurrentElementIndex(elements, currentElementKey);
  const previousElement = elements[currentElementIndex - 1];
  return previousElement ? previousElement.config.breakAfter : false;
}
